/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Manage_Storage_Pending_RemovalInputs */



/**
* | output |
* | --- |
* | "Storage add-on ending on {date}." |
*
* @param {Partner_Manage_Storage_Pending_RemovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_pending_removal = /** @type {((inputs: Partner_Manage_Storage_Pending_RemovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Pending_RemovalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher-Add-on endet am ${i?.date}.`)
	return /** @type {LocalizedString} */ (`Storage add-on ending on ${i?.date}.`)
});